import { EPagesPath } from './../../app.routes';
import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { ButtonModule } from '@usitsdasdesign/dds-ng/button';
import { HeaderOptions, HeaderElmnts, HeaderModule } from '@usitsdasdesign/dds-ng/header';
import { ProfileModule, ProfileOptions } from '@usitsdasdesign/dds-ng/profile';
import { Themes, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Destroy } from '../../core/destroyClass';
import { SearchComponent } from '../search/search.component';
import { filter, takeUntil } from 'rxjs';
import { IUserDetails } from '../search/typings';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    HeaderModule,
    ProfileModule,
    ButtonModule,
    RouterModule,
    SearchComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent extends Destroy {
  @ViewChild('header') header: ElementRef<HTMLElement>;
  EPagesPath = EPagesPath;
  ProfileVisible: boolean = false;  
  //isHidden: boolean =true;
  @Input() userDetails: any;
  

  ngOnChanges(): void {
    

  if (this.userDetails) {
    this.headerLinksBasedOnUserAccess(this.userDetails);  
    // Dynamically set profileOptions based on userDetails
    this.profileOptions = {
      username: this.userDetails[0]?.userName, // Assuming `userName` exists in IUserDetails
      nameLetter: this.userDetails[0]?.initials, // Assuming `initials` exists in IUserDetails
      stickerIndent: 8
    };
    
  }
}

  headerOptions: HeaderOptions = {
    name: 'Code of Ethics and Professional Conduct',
    width: WidthState.fixed,
    isResponsive: true,
    theme: Themes.dark
  };

  responsivePriority: HeaderElmnts[] = [
    HeaderElmnts.logo,
    HeaderElmnts.projectName,
    HeaderElmnts.profile,
    HeaderElmnts.nav,
    HeaderElmnts.search
  ];

  pages = [
    {
      label: 'Home',
      path: EPagesPath.home
    },
    {
      label: 'Contacts',
      path: EPagesPath.contacts
    }
];
  profileOptions: ProfileOptions = {
    username: '',
    nameLetter: '',
    userInfo: 'General manager',
    stickerIndent: 8
  };
  

  constructor(private renderer: Renderer2,
    private router: Router,) {
    super();   
  }

  ngAfterViewInit() {
    window.addEventListener('scroll', () => this.shownHeaderSearch(this.isAdditionalSearchHidden() && !this.isContentManagementOrArchivePage(window.location.pathname)));
    this.shownHeaderSearch(window.location.pathname !== '/' && !this.isContentManagementOrArchivePage(window.location.pathname));
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => this.shownHeaderSearch(event.url !== '/' && !this.isContentManagementOrArchivePage(event.url)));

  }

  private isContentManagementOrArchivePage(url: string): boolean {
    return url.includes(EPagesPath.contentManagement) || url.includes(EPagesPath.archive);
  }

  private shownHeaderSearch(status: boolean): void {
    const headerSearch = document.querySelector('.header__search');

    if (!headerSearch) return;

    status ?
      this.renderer.removeClass(headerSearch, 'dds-d-none') :
      this.renderer.addClass(headerSearch, 'dds-d-none');
  }

  private isAdditionalSearchHidden(): boolean {
    const searchElement = document.querySelector('app-search:not(.header__search)');

    if (!searchElement) return true;

    const headerEl = this.header.nativeElement?.getBoundingClientRect().height;
    const rect = searchElement.getBoundingClientRect();

    return rect.bottom < headerEl;
  }

  headerLinksBasedOnUserAccess(userDetails: any) {
    const user = userDetails[0];
    const hasContentEditAccess = user?.hasContentEditAccess;
    if (hasContentEditAccess) {
      this.pages.push(
      { label: 'Content Management', path: EPagesPath.contentManagement },
      { label: 'Archive', path: EPagesPath.archive }
      );
    }
  }
}
